import Colcade from 'colcade'

export default class expertsPage {
	constructor() {
		this.experts = $('.expert-tile').toArray();

		if(!MOBSIZE) {
			$('.expert-tile--content--text > *').addClass('kash ktxt kscroll korig');
		}

		$('.expert-tile').each(function(){
			if(!MOBSIZE) {
				$(this).css('margin-left', 3 + Math.random()*8+'%');
			}
		});

		if(MOBSIZE) {
			setTimeout(function(){
				window.colc = new Colcade( '.expert-tiles', {
					columns: '.grid-col',
					items: '.expert-tile'
				});
				$('.expert-tiles').addClass('sh');
			}, 200);
		}

		$(window).on('resize', function(){
			if(window.prevmobsize && window.prevmobsize != MOBSIZE) {
				$('.expert-tile').each(function(){
					if(!MOBSIZE) {
						$(this).css('margin-left', 3 + Math.random()*8+'%');
					} else {
						$(this).css('margin-left', 0);
					}
				});
			}
			if(MOBSIZE) {
				clearTimeout(window.toTime);
				window.toTime = setTimeout(function(){
					if(!window.colc && MOBSIZE) {
						window.colc = new Colcade( '.expert-tiles', {
							columns: '.grid-col',
							items: '.expert-tile'
						});
						$('.expert-tiles').addClass('sh');
						$('.expert-tile').css('margin-left', 0);
					}
				}, 200);
			} else {
				if(window.colc){
					window.colc.destroy();
					window.colc = null;
				}
			}
			window.prevmobsize = MOBSIZE;
		});

		$('.expert-tile').mouseenter(function(){
			$(this).find('.kash').removeClass('kashing').kashify();
		});

		this.binds = this.binds.bind(this);
		this.checkFilters = this.checkFilters.bind(this);
		this.checkAllowed = this.checkAllowed.bind(this);

		this.binds();
		this.actTags = [];

		for(let i=0; i<this.experts.length;i++) {
			let t = this.experts[i];
			t.data = {};
			t.data.tags = t.dataset.tags.split(', ');
			// t.data.text = t.dataset.text;
			t.data.text = $(t).find('.expert-tile--content--text').text().trim();
		}

		window.activeTags = [];
	}

	binds() {
		var page = this;
		$('.experts-tags a.tag').click(function(e){
			e.preventDefault();
			var id = $(this).attr('href').substr(1);
			var text = $(this).text();
			if(id!=='all') {
				$(this).toggleClass('act');
				// console.log(text);

				if(!$(this).hasClass('act')){
					var index = window.activeTags.indexOf(text);
					window.activeTags.splice(index,1);
					$(this).removeClass('no-hover');
				} else {
					window.activeTags.push(text);
					$(this).addClass('no-hover');
				}

			} else {
				$(this).siblings().removeClass('act');
				$(this).addClass('act');
				window.activeTags = [];
			}

			if(window.activeTags.length==0) {
				$('.tag[href="#all"]').addClass('act');
			} else {
				$('.tag[href="#all"]').removeClass('act');
			}

			page.checkFilters();
		}).mouseleave(function(){
			$(this).removeClass('no-hover');
		});

		for(let i=0; i<page.experts.length; i++){
			$(page.experts[i]).addClass('inview');
		}

		$(window).scroll(function(){
			for(let i=0; i<page.experts.length; i++){
			// $('.expert-tile').each(function(){
				var rect = page.experts[i].getBoundingClientRect();
				if(rect.top <  window.innerHeight && rect.bottom > 0){
					$(page.experts[i]).addClass('inview');
				} else {
					$(page.experts[i]).removeClass('inview');
				}
			}
		});
	}

	checkFilters(){
		console.log('checking');
		setTimeout(function(){
			$(window).trigger('scroll');
		}, 200);
		this.experts.forEach((t) => {
			var tags = t.data.tags; 
			var text = t.data.text; 

			let allowed = this.checkAllowed(tags);
			// console.log('allowed ',allowed);

			if(allowed) {
				if($(t).hasClass('out')) {
					$(t).removeClass('out').stop().show(MOBSIZE ? 0 : 300, function(){
						clearTimeout(window.scr);
						window.scr = setTimeout(function(){
							$(window).trigger('scroll');
						}, 20);
					});
				}
				// visibleCount++;
			} else {
				if(!$(t).hasClass('out')){
					$(t).addClass('out').stop().hide(MOBSIZE ? 0 : 300, function(){
						clearTimeout(window.scr);
						window.scr = setTimeout(function(){
							$(window).trigger('scroll');
						}, 20);
					});
					$(window).trigger('scroll');
					// setTimeout(function(){
						// $(window).trigger('scroll');
					// }, 200);
				}
			}
		});

		if(window.colc) window.colc.layout();

		// setTimeout(function(){
		// 	if(window.colc) window.colc.layout();
		// }, 100);

		// setTimeout(function(){
		// 	if(window.colc) window.colc.layout();
		// }, 200);
		
		// setTimeout(function(){
		// 	if(window.colc) window.colc.layout();
		// }, 330);
	}


	checkAllowed(tags){
		let allowed = false;

		if(window.activeTags.length>0){
			allowed = false;
			var alloweds = 0;
			if(tags) {
				for(let t=0;t<tags.length;t++) {
					// for(var n=0;n<window.activeTags.length;n++){
					// 	if(tags[t].trim() == window.activeTags[n].trim()){
					// 		allowed = true;
					// 		// console.log('shud be allowed!');
					// 	}
					// }
					for(var n=0;n<window.activeTags.length;n++){
						if(tags[t].trim() == window.activeTags[n].trim()){
							alloweds++;
							// console.log('shud be allowed!');
						}
					}
				}
				allowed = alloweds==window.activeTags.length;
			} else {
				allowed = false;
			}
		} else {
			allowed = true;
		}
		return allowed;
	}
}